import { logoutUser } from "../redux/auth/authSlice";
import { useAppDispatch } from "../hooks/useAppSelector";

export const useLogout = () => {
    const dispatch = useAppDispatch()

    return { logout: async () => dispatch(logoutUser()) }
}
